import AppService from "./app.service";
import { base64ToImage, textToDom, blobUrlToFile } from "../utils/utils";
import uuid from "react-uuid";
import { getAwsSignedUrlForView, imageUploadToS3 } from "./AwsBackEndService";
import { Configs } from "../constants";

const getMessageData = async (messageData) => {
  let content = messageData.content;
  const imagePathSubstring = Configs.aws.s3.bucketName;
  const adContentHTML = textToDom(content);
  const images = adContentHTML.querySelectorAll("img");
  for (const img of images) {
    const imgSrc = img.getAttribute("src");
    if (!imgSrc.includes(imagePathSubstring)) {
      const file = base64ToImage(imgSrc, uuid());
      const uploadedFileObject = await imageUploadToS3(
        "clientMessages/images/",
        file
      );
      img.setAttribute("src", uploadedFileObject.fileKey);
    } else if (imgSrc.includes(imagePathSubstring)) {
      // set the object key (relative path) before saving the data
      const regExpr = "clientMessages/images/([^?]+)";
      img.setAttribute("src", imgSrc.match(regExpr)[0]);
    }
  }

  const videos = adContentHTML.querySelectorAll("iframe");
  for (const video of videos) {
    const src = video.getAttribute("src");
    if (!src.includes(imagePathSubstring)) {
      const file = await blobUrlToFile(src, uuid());
      const uploadedFileObject = await imageUploadToS3(
        "clientMessages/videos/",
        file
      );
      video.setAttribute("src", uploadedFileObject.fileKey);
    } else if (src.includes(imagePathSubstring)) {
      // set the object key (relative path) before saving the data
      const regExpr = "clientMessages/videos/([^?]+)";
      video.setAttribute("src", src.match(regExpr)[0]);
    }
  }

  content = adContentHTML.body.innerHTML;

  return { ...messageData, content };
};

export const getAwsUrlToViewMedia = async (messageContent) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(messageContent, "text/html");

  // Get all <img> elements
  const imgs = Array.from(doc.querySelectorAll("img"));

  for (const img of imgs) {
    const src = img.getAttribute("src"); // get src directly

    if (src) {
      // Call your AWS function to get the signed URL
      await getAwsSignedUrlForView(src, "image/png", (url) => {
        img.setAttribute("src", url); // replace src in DOM
      });
    }
  }

  // Get all <iframe> elements (video)
  const iframes = Array.from(doc.querySelectorAll("iframe"));

  for (const iframe of iframes) {
    const videoSrc = iframe.getAttribute("src");
    if (videoSrc) {
      await getAwsSignedUrlForView(videoSrc, "video/mp4", (url) => {
        iframe.setAttribute("src", url);
      });
    }
  }
  const updatedMessageContent = doc.body.innerHTML;
  return updatedMessageContent;
};

export const MessageService = Object.freeze({
  saveMessage: async (messageData, url) => {
    const updatedMessageData = await getMessageData(messageData);
    return await AppService.submit(updatedMessageData, url);
  },

  updateMessageById: async (messageId, messageData) => {
    const updatedMessageData = await getMessageData(messageData);
    return await AppService.update(updatedMessageData, "messages", messageId);
  },

  getMessageById: async (messageId) => {
    const message = await AppService.get(messageId, "messages");
    const messageContent = await getAwsUrlToViewMedia(message.content);

    return {
      ...message,
      label: message.title,
      clientViewer: message.clientViewer,
      content: messageContent,
    };
  },

  getAllUserMessages: async (accId, userId) => {
    const result = await AppService.getAllWithData(
      `messages/getUserMessages/${accId}`,
      userId
    );
    return result?.data || [];
  },

  dontShowMessageAgain: async (accId, userId, messageIds) => {
    return await AppService.submit(
      { accId, userId, messagesIds: messageIds },
      "messages/dontShowMessageAgain"
    );
  },
});
